// extracted by mini-css-extract-plugin
module.exports = {"gxvzyp6":"gxvzyp6","flash-gxvzyp6":"flash-gxvzyp6"};